define("shared/components/shared/profile-categorization/rewards-steps/report", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@glimmer/tracking", "@ember/service", "@ember/object/computed"], function (_exports, _component, _templateFactory, _component2, _object, _tracking, _service, _computed) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@glimmer/tracking",0,"@ember/service",0,"@ember/object/computed",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::ProfileCategorization::CategorizeSteps::ProgressBar
    @socialProfile={{@socialProfile}}
    @progressValue={{1}}
  />
  
  {{#let (concat "profile_categorization.reports." @sectionName ".") as |prefix|}}
    {{#if (or @forceHideReports (not this.isInstagramProfile))}}
      <div {{did-insert (fn @setReportState true)}}>
        <Shared::ProfileCategorization::RewardsSteps::Report::None
          @prefix={{prefix}}
          @socialProfile={{@socialProfile}}
          @isModalFlow={{this.isModalFlow}}
          @clearSelectedCategory={{this.clearSelectedCategory}}
          @exitCategorization={{@exitCategorization}}
        />
      </div>
    {{else if this.showPartnershipsOptIn}}
      <div {{did-insert (fn @setReportState true)}} {{track "viewed-creator-optin-self-cat"}}>
        <Shared::ProfileCategorization::RewardsSteps::PartnershipsOptIn
          @prefix={{prefix}}
          @socialProfile={{@socialProfile}}
          @clearSelectedCategory={{this.clearSelectedCategory}}
          @exitCategorization={{@exitCategorization}}
          @goToPartnerships={{this.goToPartnerships}}
        />
      </div>
    {{else}}
      <Shared::ProfileCategorization::RewardsSteps::ProvideProfileReportData
        @socialProfile={{@socialProfile}}
      as |profileReportData|>
        <Shared::ProfileCategorization::RewardsSteps::ProvideIndustryReportData
          @socialProfile={{@socialProfile}}
          @averageProfileEngagement={{profileReportData.averageProfileEngagement}}
        as |industryReportData|>
          {{#if (or profileReportData.isLoading industryReportData.isLoading)}}
            <Shared::ProfileCategorization::Loading />
          {{else if (and profileReportData.hasEnoughPosts industryReportData.isIndustryDataPresent)}}
            <div {{did-insert (fn @setReportState false)}}>
              {{#if this.showReportsStep}}
                <Shared::ProfileCategorization::RewardsSteps::Report::Full
                  @prefix={{prefix}}
                  @profileReportData={{profileReportData}}
                  @industryReportData={{industryReportData}}
                  @socialProfile={{@socialProfile}}
                  @sectionName={{@sectionName}}
                  @currentTabNum={{this.currentTabNum}}
                  @clearSelectedCategory={{this.clearSelectedCategory}}
                  @isModalFlow={{this.isModalFlow}}
                  @changeTabNum={{this.changeTabNum}}
                  @exitCategorization={{@exitCategorization}}
                />
              {{else}}
                <Shared::ProfileCategorization::RewardsSteps::Report::GoToFull
                  @prefix={{prefix}}
                  @socialProfile={{@socialProfile}}
                  @isAnalyticsFlow={{this.isAnalyticsFlow}}
                  @toggleShowReportsStep={{set this "showReportsStep" true}}
                  @clearSelectedCategory={{this.clearSelectedCategory}}
                  @trackSkipRewards={{this.trackSkipRewards}}
                  @exitCategorization={{@exitCategorization}}
                />
              {{/if}}
            </div>
          {{else if industryReportData.isIndustryDataPresent}}
            <div {{did-insert (fn @setReportState false)}}>
              {{#if this.showReportsStep}}
                <Shared::ProfileCategorization::RewardsSteps::Report::Partial
                  @prefix={{prefix}}
                  @industryReportData={{industryReportData}}
                  @socialProfile={{@socialProfile}}
                  @sectionName={{@sectionName}}
                  @clearSelectedCategory={{this.clearSelectedCategory}}
                  @isModalFlow={{this.isModalFlow}}
                  @exitCategorization={{@exitCategorization}}
                />
              {{else}}
                <Shared::ProfileCategorization::RewardsSteps::Report::GoToPartial
                  @prefix={{prefix}}
                  @socialProfile={{@socialProfile}}
                  @clearSelectedCategory={{this.clearSelectedCategory}}
                  @isAnalyticsFlow={{this.isAnalyticsFlow}}
                  @trackSkipRewards={{this.trackSkipRewards}}
                  @toggleShowReportsStep={{set this "showReportsStep" true}}
                  @exitCategorization={{@exitCategorization}}
                />
              {{/if}}
            </div>
          {{else}}
            <div {{did-insert (fn @setReportState true)}}>
              <Shared::ProfileCategorization::RewardsSteps::Report::NotAvailable
                @prefix={{prefix}}
                @socialProfile={{@socialProfile}}
                @isModalFlow={{this.isModalFlow}}
                @clearSelectedCategory={{this.clearSelectedCategory}}
                @exitCategorization={{@exitCategorization}}
              />
            </div>
          {{/if}}
        </Shared::ProfileCategorization::RewardsSteps::ProvideIndustryReportData>
      </Shared::ProfileCategorization::RewardsSteps::ProvideProfileReportData>
    {{/if}}
  {{/let}}
  
  */
  {
    "id": "XW05ECbC",
    "block": "[[[8,[39,0],null,[[\"@socialProfile\",\"@progressValue\"],[[30,1],1]],null],[1,\"\\n\\n\"],[44,[[28,[37,2],[\"profile_categorization.reports.\",[30,2],\".\"],null]],[[[41,[28,[37,4],[[30,4],[28,[37,5],[[30,0,[\"isInstagramProfile\"]]],null]],null],[[[1,\"    \"],[11,0],[4,[38,6],[[28,[37,7],[[30,5],true],null]],null],[12],[1,\"\\n      \"],[8,[39,8],null,[[\"@prefix\",\"@socialProfile\",\"@isModalFlow\",\"@clearSelectedCategory\",\"@exitCategorization\"],[[30,3],[30,1],[30,0,[\"isModalFlow\"]],[30,0,[\"clearSelectedCategory\"]],[30,6]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showPartnershipsOptIn\"]],[[[1,\"    \"],[11,0],[4,[38,6],[[28,[37,7],[[30,5],true],null]],null],[4,[38,9],[\"viewed-creator-optin-self-cat\"],null],[12],[1,\"\\n      \"],[8,[39,10],null,[[\"@prefix\",\"@socialProfile\",\"@clearSelectedCategory\",\"@exitCategorization\",\"@goToPartnerships\"],[[30,3],[30,1],[30,0,[\"clearSelectedCategory\"]],[30,6],[30,0,[\"goToPartnerships\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,11],null,[[\"@socialProfile\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,12],null,[[\"@socialProfile\",\"@averageProfileEngagement\"],[[30,1],[30,7,[\"averageProfileEngagement\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[28,[37,4],[[30,7,[\"isLoading\"]],[30,8,[\"isLoading\"]]],null],[[[1,\"          \"],[8,[39,13],null,null,null],[1,\"\\n\"]],[]],[[[41,[28,[37,14],[[30,7,[\"hasEnoughPosts\"]],[30,8,[\"isIndustryDataPresent\"]]],null],[[[1,\"          \"],[11,0],[4,[38,6],[[28,[37,7],[[30,5],false],null]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showReportsStep\"]],[[[1,\"              \"],[8,[39,15],null,[[\"@prefix\",\"@profileReportData\",\"@industryReportData\",\"@socialProfile\",\"@sectionName\",\"@currentTabNum\",\"@clearSelectedCategory\",\"@isModalFlow\",\"@changeTabNum\",\"@exitCategorization\"],[[30,3],[30,7],[30,8],[30,1],[30,2],[30,0,[\"currentTabNum\"]],[30,0,[\"clearSelectedCategory\"]],[30,0,[\"isModalFlow\"]],[30,0,[\"changeTabNum\"]],[30,6]]],null],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[39,16],null,[[\"@prefix\",\"@socialProfile\",\"@isAnalyticsFlow\",\"@toggleShowReportsStep\",\"@clearSelectedCategory\",\"@trackSkipRewards\",\"@exitCategorization\"],[[30,3],[30,1],[30,0,[\"isAnalyticsFlow\"]],[28,[37,17],[[30,0],\"showReportsStep\",true],null],[30,0,[\"clearSelectedCategory\"]],[30,0,[\"trackSkipRewards\"]],[30,6]]],null],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n\"]],[]],[[[41,[30,8,[\"isIndustryDataPresent\"]],[[[1,\"          \"],[11,0],[4,[38,6],[[28,[37,7],[[30,5],false],null]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showReportsStep\"]],[[[1,\"              \"],[8,[39,18],null,[[\"@prefix\",\"@industryReportData\",\"@socialProfile\",\"@sectionName\",\"@clearSelectedCategory\",\"@isModalFlow\",\"@exitCategorization\"],[[30,3],[30,8],[30,1],[30,2],[30,0,[\"clearSelectedCategory\"]],[30,0,[\"isModalFlow\"]],[30,6]]],null],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[39,19],null,[[\"@prefix\",\"@socialProfile\",\"@clearSelectedCategory\",\"@isAnalyticsFlow\",\"@trackSkipRewards\",\"@toggleShowReportsStep\",\"@exitCategorization\"],[[30,3],[30,1],[30,0,[\"clearSelectedCategory\"]],[30,0,[\"isAnalyticsFlow\"]],[30,0,[\"trackSkipRewards\"]],[28,[37,17],[[30,0],\"showReportsStep\",true],null],[30,6]]],null],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[11,0],[4,[38,6],[[28,[37,7],[[30,5],true],null]],null],[12],[1,\"\\n            \"],[8,[39,20],null,[[\"@prefix\",\"@socialProfile\",\"@isModalFlow\",\"@clearSelectedCategory\",\"@exitCategorization\"],[[30,3],[30,1],[30,0,[\"isModalFlow\"]],[30,0,[\"clearSelectedCategory\"]],[30,6]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]],[]]]],[]]],[1,\"      \"]],[8]]]]],[1,\"\\n    \"]],[7]]]]],[1,\"\\n  \"]],[]]]],[]]]],[3]]]],[\"@socialProfile\",\"@sectionName\",\"prefix\",\"@forceHideReports\",\"@setReportState\",\"@exitCategorization\",\"profileReportData\",\"industryReportData\"],false,[\"shared/profile-categorization/categorize-steps/progress-bar\",\"let\",\"concat\",\"if\",\"or\",\"not\",\"did-insert\",\"fn\",\"shared/profile-categorization/rewards-steps/report/none\",\"track\",\"shared/profile-categorization/rewards-steps/partnerships-opt-in\",\"shared/profile-categorization/rewards-steps/provide-profile-report-data\",\"shared/profile-categorization/rewards-steps/provide-industry-report-data\",\"shared/profile-categorization/loading\",\"and\",\"shared/profile-categorization/rewards-steps/report/full\",\"shared/profile-categorization/rewards-steps/report/go-to-full\",\"set\",\"shared/profile-categorization/rewards-steps/report/partial\",\"shared/profile-categorization/rewards-steps/report/go-to-partial\",\"shared/profile-categorization/rewards-steps/report/not-available\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/report.hbs",
    "isStrictMode": false
  });

  let Report = (_dec = (0, _computed.equal)('args.socialProfile.type', 'InstagramProfile'), _dec2 = (0, _computed.equal)('args.sectionName', 'add_profile'), _dec3 = (0, _computed.equal)('args.sectionName', 'analytics'), _dec4 = (0, _computed.or)('isAddProfileFlow', 'isAnalyticsFlow'), (_class = class Report extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "segment", _descriptor2, this);

      _initializerDefineProperty(this, "errors", _descriptor3, this);

      _initializerDefineProperty(this, "intl", _descriptor4, this);

      _initializerDefineProperty(this, "router", _descriptor5, this);

      _initializerDefineProperty(this, "showReportsStep", _descriptor6, this);

      _initializerDefineProperty(this, "currentTabNum", _descriptor7, this);

      _initializerDefineProperty(this, "isInstagramProfile", _descriptor8, this);

      _initializerDefineProperty(this, "isAddProfileFlow", _descriptor9, this);

      _initializerDefineProperty(this, "isAnalyticsFlow", _descriptor10, this);

      _initializerDefineProperty(this, "isModalFlow", _descriptor11, this);
    }

    get showPartnershipsOptIn() {
      return this.args.sectionName === 'signup' && this.args.businessModel === 'blog_influencer' && (this.args.socialProfile.followedBy > 100 || this.args.socialProfile.followedBy === null) && this.args.socialProfile.isProfessional && this.auth.currentAccount.canInfluencerOptIn;
    }

    changeTabNum(tabNum) {
      this.currentTabNum = tabNum;
    }

    clearSelectedCategory(page) {
      this._trackRestartedCategorization(page);

      this.args.resetSelection();
    }

    goToPartnerships() {
      if (typeof this.args.exitCategorization === 'function') {
        this.args.exitCategorization(true);
      }

      const groupSlug = this.args.socialProfile.group.get('slug');
      this.router.transitionTo('cluster.partnerships.profile', groupSlug, this.args.socialProfile.socialIdentity.get('id'));
    }

    trackSkipRewards() {
      const {
        id,
        industry,
        businessModel,
        category,
        nickname
      } = this.args.socialProfile || {};
      this.segment.track('skipped-industry-comparison-self-cat', {
        profile: id,
        area: this.args.sectionName,
        bus_model: businessModel,
        industry,
        category,
        nickname
      });
    }

    _trackRestartedCategorization(page) {
      const eventName = 'redid-self-cat';
      const {
        id,
        nickname
      } = this.args.socialProfile || {};
      const user = this.auth.currentUserModel.id;

      try {
        this.segment.track(eventName, {
          area: this.args.sectionName,
          user,
          profile: id,
          page,
          social_profile_nickname: nickname
        });
      } catch (error) {
        this.errors.handleAdapter(new Error("Error Tracking ".concat(eventName, " from location ").concat(this.args.sectionName)), error);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showReportsStep", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currentTabNum", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 2;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isInstagramProfile", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isAddProfileFlow", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "isAnalyticsFlow", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isModalFlow", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "changeTabNum", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "changeTabNum"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSelectedCategory", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearSelectedCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToPartnerships", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToPartnerships"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackSkipRewards", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackSkipRewards"), _class.prototype)), _class));
  _exports.default = Report;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Report);
});